module.exports = __webpack_public_path__ + "static/media/94.cf130f9d.png";